import { ChipOwnProps, SxProps, Theme } from '@mui/material';

type Color = 'success' | 'info' | 'warning' | 'error';

export interface AlertLayoutProps {
  key?: string;
  severity?: Color;
  onClose?: () => void;
  className?: string;
  children?: React.ReactNode;
  color?: Color;
  sx?: SxProps<Theme>;
  icon?: React.ReactNode;
}

type BasePlacement = 'top' | 'bottom' | 'right' | 'left';
type VariationPlacement =
  | 'top-start'
  | 'top-end'
  | 'bottom-start'
  | 'bottom-end'
  | 'right-start'
  | 'right-end'
  | 'left-start'
  | 'left-end';
type AutoPlacement = 'auto' | 'auto-start' | 'auto-end';
type Placement = BasePlacement | VariationPlacement | AutoPlacement;

export enum FloatingPlacement {
  RIGHT = 'right',
  TOP_START = 'top-start',
  TOP = 'top',
  TOP_END = 'top-end',
  RIGHT_START = 'right-start',
  RIGHT_END = 'right-end',
  BOTTOM_END = 'bottom-end',
  BOTTOM = 'bottom',
  BOTTOM_START = 'bottom-start',
  LEFT_END = 'left-end',
  LEFT = 'left',
  LEFT_START = 'left-start',
}
export interface TooltipLayoutProps {
  id?: string;
  arrow?: boolean;
  placement?: Placement;
  title: React.ReactNode;
  children: React.ReactElement<unknown, any>;
}

export interface ButtonLayoutProps {
  link?: boolean;
  sx?: SxProps<Theme>;
  disableRipple?: boolean;
  disableFocusRipple?: boolean;
  color?: BasicColors;
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  variant?: 'text' | 'outlined' | 'contained';
  size?: 'small' | 'medium' | 'large';
  type?: 'button' | 'submit' | 'reset';
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  disabled?: boolean;
  style?: React.CSSProperties;
}

export interface FadeLayoutProps {
  in?: boolean;
  timeout?: number;
  className?: string;
  children: React.ReactElement<unknown, any>;
}

export interface LoadingLayoutProps {
  size?: string;
  hasBackground?: boolean;
  hasPositionFixed?: boolean;
  isInitialPosition?: boolean;
  sx?: SxProps<Theme>;
}

export interface SmallLoaderLayoutProps {
  className?: string;
  size?: string;
}

export interface InputLoaderLayoutProps {
  className?: string;
}

export interface BadgeLayoutProps {
  className?: string;
  color?: ChipOwnProps['color'];
  children?: React.ReactNode;
  isVisible?: boolean | ((data: any) => boolean);
  id?: string;
  sx?: SxProps<Theme>;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}
